import { EventEmitter, Injectable, Injector, Output } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

import { BaseService } from "../shared/services/base.service";
import { Parceiro } from "../models/parceiro.model";

@Injectable({
  providedIn: "root",
})
export class ParceirosService extends BaseService<Parceiro> {
  novoDado: any = new EventEmitter();

  constructor(protected injector: Injector) {
    super(`${environment.API_PRICE}`, injector);
  }

  getParceiros(): Observable<Parceiro[]> {
    return this.http.get<Parceiro[]>(`${environment.API_PRICE}/Parceiro`);
  }


  getParceirosAtivos(): Observable<Parceiro[]> {
    return this.http.get<Parceiro[]>(`${environment.API_PRICE}/Parceiro/GetAtivos`);
  }


  updateNome(atualizarParceiro) {
    return this.http.put(
      `${environment.API_PRICE}/Parceiro/${atualizarParceiro.id}`,
      atualizarParceiro
    );
  }

  inativaParceiro(registroInativado) {
    return this.http.put(
      `${environment.API_PRICE}/Parceiro/${registroInativado.id}`,
      registroInativado
    );
  }

  criarParceiro(parceiroCriado) {
    return this.http.post(`${environment.API_PRICE}/parceiro`, parceiroCriado);
  }

  updateTable(dataModal) {
    this.novoDado.emit(dataModal);
  }
}
